export const getTabValue = (tab) => {
   switch (tab) {
      case "Assigned":
      case "Whatsapp":
         return 0;
      case "Rejected":
      case "Email":
         return 1;
      case "In Progress":
         return 2;
      case "Completed":
      case "Finished":
         return 3;
      default:
         return null;
   }
};
